// src/types/profile.ts
export interface UserDemographics {
    ageRange: 'under-18' | '18-25' | '26-35' | '36-45' | '46-55' | '56-65' | 'over-65' | null;
    gender: 'male' | 'female' | 'non-binary' | 'prefer-not-to-say' | null;
    homeCountry: string | null;
    primaryLanguage: string | null;
  }
  
  export interface TravelPreferences {
    travelStyle: ('luxury' | 'budget' | 'adventure' | 'cultural' | 'relaxation' | 'eco-tourism')[];
    pace: 'fast' | 'moderate' | 'slow' | null;
    foodPreferences: ('vegetarian' | 'vegan' | 'local-cuisine' | 'fine-dining' | 'street-food' | 'dietary-restrictions')[];
    dietaryRestrictions: string | null;
  }
  
  export interface InterestsActivities {
    cultural: ('museums' | 'history' | 'art' | 'architecture' | 'local-traditions')[];
    nature: ('hiking' | 'beaches' | 'safaris' | 'camping' | 'stargazing' | 'wildlife')[];
    urban: ('nightlife' | 'shopping' | 'restaurants' | 'markets' | 'street-art')[];
    adventure: ('skiing' | 'diving' | 'surfing' | 'climbing' | 'extreme-sports')[];
    wellness: ('spas' | 'yoga' | 'meditation' | 'health-retreats')[];
    familyFriendly: ('kid-attractions' | 'theme-parks' | 'educational-tours' | 'family-activities')[];
  }
  
  export interface PracticalConstraints {
    budgetRange: 'budget' | 'mid-range' | 'luxury' | 'no-limit' | null;
    timeAvailability: 'short-trips' | 'week-long' | 'extended' | 'flexible' | null;
    accessibilityNeeds: string | null;
    safetyConsiderations: string | null;
  }
  
  export interface CompleteUserProfile {
    demographics: UserDemographics;
    travelPreferences: TravelPreferences;
    interests: InterestsActivities;
    constraints: PracticalConstraints;
    completedAt: Date | null;
    /** Set when the user explicitly skipped onboarding. Stops us
     *  from re-prompting them on every login. They can still
     *  complete the profile later via Settings → Travel Profile. */
    skippedOnboardingAt?: Date | null;
    lastUpdated: Date;
  }
  
  export const DEFAULT_USER_PROFILE: CompleteUserProfile = {
    demographics: {
      ageRange: null,
      gender: null,
      homeCountry: null,
      primaryLanguage: null,
    },
    travelPreferences: {
      travelStyle: [],
      pace: null,
      foodPreferences: [],
      dietaryRestrictions: null,
    },
    interests: {
      cultural: [],
      nature: [],
      urban: [],
      adventure: [],
      wellness: [],
      familyFriendly: [],
    },
    constraints: {
      budgetRange: null,
      timeAvailability: null,
      accessibilityNeeds: null,
      safetyConsiderations: null,
    },
    completedAt: null,
    lastUpdated: new Date(),
  };